/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountRoutingModule
 * Purpose		: Routing module for SalesTotalsbyAmount.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SalesTotalsbyAmountListComponent } from './SalesTotalsbyAmountList.component';
import { SalesTotalsbyAmountDetailsComponent } from './SalesTotalsbyAmountDetails.component';

const SalesTotalsbyAmountRoutes: Routes = [
	{ path: 'SalesTotalsbyAmount',  component: SalesTotalsbyAmountListComponent },
	{ path: 'SalesTotalsbyAmount/Details/:id', component: SalesTotalsbyAmountDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(SalesTotalsbyAmountRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SalesTotalsbyAmountRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesTotalsbyAmount/SalesTotalsbyAmount-routing.module.ts